import { styled } from "styled-components";

const SettingsMainContent = styled.div`
  padding: var(--space-300);
`;

export default SettingsMainContent;
